import { Box, Typography } from '@customink/pigment-react';
import { useMobileBreakpoint } from '@customink/project-service-react-components';

type ShippingSpeedProps = {
  title?: string;
  children: React.ReactNode;
};

export default function ShippingSpeed({
  title = 'Shipping Speed',
  children,
}: ShippingSpeedProps) {
  const isMobile = useMobileBreakpoint();

  return (
    <Box data-testid="shipping-speed">
      <Typography
        component="h3"
        sx={{
          marginBottom: '11px',
          fontWeight: 'bold',
          fontSize: '18px',
          lineHeight: '22px',
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
